var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import classNames from 'classnames';
import { validateColorPreset, validateLabelPositionPreset } from '../../utils/presetValidator';
import '../../css/clydeCheckbox.css';
var ClydeCheckbox = function (props) {
    var autofocus = props.autofocus, backgroundColor = props.backgroundColor, checked = props.checked, className = props.className, disabled = props.disabled, greyLabel = props.greyLabel, hidden = props.hidden, id = props.id, label = props.label, labelPosition = props.labelPosition, name = props.name, onChange = props.onChange, readonly = props.readonly, scale = props.scale, value = props.value, dataTestValue = props.dataTestValue;
    var _changeHandler = function (e) {
        e.stopPropagation();
        if (!disabled && !hidden && !readonly) {
            onChange(e);
        }
    };
    var _labelOnClick = function (e) {
        e.preventDefault(); // Prevents focusing of checkbox button when label is clicked
        var processedEvent = __assign({}, e);
        processedEvent.target.name = name;
        _changeHandler(e);
    };
    var _backgroundColor = 'clydeBlue'; // Default color
    if (backgroundColor !== undefined && validateColorPreset(backgroundColor)) {
        _backgroundColor = backgroundColor;
    }
    var _labelPosition = 'right'; // Default position
    if (labelPosition !== undefined && validateLabelPositionPreset(labelPosition)) {
        _labelPosition = labelPosition;
    }
    var _containerClassName = classNames('clyde-checkbox', "clyde-checkbox-".concat(_labelPosition), className, {
        'clyde-checkbox--disabled': disabled,
        'clyde-checkbox--hidden': hidden,
    });
    var _buttonClassName = classNames('clyde-checkbox-button', "clyde-checkbox-button--".concat(_backgroundColor));
    var _labelClassName = classNames('clyde-checkbox-label', {
        'clyde-checkbox-label--grey': greyLabel,
    });
    var inlineStyle = {
        transform: scale ? "scale(".concat(scale, ")") : '',
    };
    return (React.createElement("div", { className: _containerClassName, "data-test": dataTestValue },
        React.createElement("input", { autoFocus: autofocus, checked: checked, className: _buttonClassName, disabled: disabled, id: id || '', name: name, onChange: _changeHandler, onMouseUp: function (e) { e.currentTarget.blur(); }, readOnly: readonly, style: inlineStyle, type: 'checkbox', value: value }),
        label
            && React.createElement("label", { className: _labelClassName, htmlFor: id || '', onClick: _labelOnClick }, label)));
};
export default ClydeCheckbox;
